module.exports = __webpack_public_path__ + "img/man_with_arm_injury@2x.a977aa0e.png";